<template>
    <div class="project_home">
        <div class="project_content">
            <div v-show="preengage.medical_exam_date">
                <h2 class="project-title">体检预约记录</h2>
                <div style="padding:0 10px">
                    <el-row :gutter="10">
                        <el-col :sm="24" >
                            <div class="project_item">
                                <span class="project_date">日期：{{preengage.medical_exam_date}}</span>
                                <br>
                                <span class="project_date">医院：{{preengage.hospital}}</span>
                            </div>
                        </el-col>
                    </el-row>
                </div>
                <div style="text-align:center;margin-top:20px;">
                    <el-button type="primary" style="width:300px" @click="cancelPreengageExam">取消体检预约</el-button>
                </div>
            </div>
            <h2 class="project-title">现场确认预约记录</h2>
            <div style="padding:0 10px">
                <el-row :gutter="10">
                    <el-col :sm="24" >
                        <div class="project_item">
                            <span class="project_date">日期：{{confirm.confirm_date}}</span>
                            <span class="project_time">{{confirm.confirm_time}}</span>
                            <br>
                            <span class="project_date">地址：{{confirm.address}}</span>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div style="text-align:center;margin-top:20px;">
                <el-button type="primary" style="width:300px" @click="cancelPreengage">取消现场预约</el-button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            preengage:{},
            confirm:{}
        }
    },
    mounted(){
        switch(this.$global.status){
            case -1:
                this.$router.push('/schoolHome/login')
                break;
            case 0:
                this.$router.push('/schoolHome/homepage')
                break; 
            case 1:
                this.$router.push('/schoolHome/projectRecord')
                break;
        }
        this.getInfo()
        this.getConfirmInfo()
    },
    methods:{
        getInfo(){
            this.$request.getNDNF(this.$url.type.base,this.$url.school.orderDetail,success=>{
                this.preengage = success.data
            })
        },
        getConfirmInfo(){
            this.$request.getNDNF(this.$url.type.base,this.$url.school.confirmOrderDetail,success=>{
                this.confirm = success.data
            })
        },
        cancelPreengageExam(){
            this.$request.postFormNF(this.$url.type.base,this.$url.school.confirmOrderCancel,{id:this.confirm.id},success=>{
                this.$request.postFormNF(this.$url.type.base,this.$url.school.orderCancel,{id:this.preengage.id},success=>{
                    this.$router.push('/schoolHome/projectList')
                    this.$message.success('取消成功')
                })
            })
        },
        cancelPreengage(){
            this.$request.postFormNF(this.$url.type.base,this.$url.school.confirmOrderCancel,{id:this.confirm.id},success=>{
                this.$router.push('/schoolHome/projectRecord')
                this.$message.success('取消成功')
            })
        },
    }
}
</script>
<style scoped>
    .project_home{
        position: absolute;
        left:0;
        right:0;
        top:0;
        bottom:70px;
        padding-bottom:10px;
        background-color:#f1f1f1;
        background-image: linear-gradient(to top, #6a85b6 0%, #bac8e0 100%);
        overflow-y: auto;
    }

    .project-title{
        text-align:center;
        padding:10px;
        color:#454545;
    }

    .project_content{
        width:800px;
        margin:0 auto;       
    }

    .project_item{ 
        margin-top:10px;
        background-image: linear-gradient(to top, #a8edea 0%, #fed6e3 100%);
        border-radius: 5px;
        line-height: 40px;
        padding:10px;
    }

    .project_date{
        font-size:18px;
        font-weight: bold;
        color:#12731e;
    }

    .project_time{
        font-size:18px;
        color:#12731e;
        font-weight: bold;
        margin-left:10px;
    }

    .project_number{
        font-size:18px;
        color:#1f0d3c;
        margin-left:10px;
    }

    @media (max-width:768px){
        .project_content{
            width:100%;
        }
    }
</style>